import { SvgIcon } from "@mui/material";
import { CSSProperties } from "react";

const PrinterIcon = ({
  active,
  scale,
  color,
  style,
}: {
  active?: boolean;
  scale?: number;
  color?: string;
  style?: CSSProperties;
}) => {
  let c = active ? "#1062D0" : "#fff";
  if (color) c = color;
  return (
    <SvgIcon
      style={{ fontSize: "20px" }}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_6001_16063)">
        <path
          d="M17.0701 5.03906H16.5232V2.92969C16.5232 1.31426 15.2089 0 13.5935 0H6.40601C4.79058 0 3.47632 1.31426 3.47632 2.92969V5.03906H2.92944C1.31401 5.03906 -0.000244141 6.35332 -0.000244141 7.96875V12.6562C-0.000244141 14.2717 1.31401 15.5859 2.92944 15.5859H3.47632V18.2422C3.47632 19.2114 4.26487 20 5.23413 20H14.7654C15.7346 20 16.5232 19.2114 16.5232 18.2422V15.5859H17.0701C18.6855 15.5859 19.9998 14.2717 19.9998 12.6562V7.96875C19.9998 6.35332 18.6855 5.03906 17.0701 5.03906ZM4.64819 2.92969C4.64819 1.96043 5.43675 1.17188 6.40601 1.17188H13.5935C14.5628 1.17188 15.3513 1.96043 15.3513 2.92969V5.03906H4.64819V2.92969ZM15.3513 18.2422C15.3513 18.5653 15.0885 18.8281 14.7654 18.8281H5.23413C4.91104 18.8281 4.64819 18.5653 4.64819 18.2422V12.4609H15.3513V18.2422ZM18.8279 12.6562C18.8279 13.6255 18.0393 14.4141 17.0701 14.4141H16.5232V12.4609H16.8748C17.1983 12.4609 17.4607 12.1986 17.4607 11.875C17.4607 11.5514 17.1983 11.2891 16.8748 11.2891H3.12476C2.80116 11.2891 2.53882 11.5514 2.53882 11.875C2.53882 12.1986 2.80116 12.4609 3.12476 12.4609H3.47632V14.4141H2.92944C1.96019 14.4141 1.17163 13.6255 1.17163 12.6562V7.96875C1.17163 6.99949 1.96019 6.21094 2.92944 6.21094H17.0701C18.0393 6.21094 18.8279 6.99949 18.8279 7.96875V12.6562Z"
          fill={c}
        />
        <path
          d="M11.5623 13.7891H8.43726C8.11366 13.7891 7.85132 14.0514 7.85132 14.375C7.85132 14.6986 8.11366 14.9609 8.43726 14.9609H11.5623C11.8859 14.9609 12.1482 14.6986 12.1482 14.375C12.1482 14.0514 11.8859 13.7891 11.5623 13.7891Z"
          fill={c}
        />
        <path
          d="M11.5623 16.2891H8.43726C8.11366 16.2891 7.85132 16.5514 7.85132 16.875C7.85132 17.1986 8.11366 17.4609 8.43726 17.4609H11.5623C11.8859 17.4609 12.1482 17.1986 12.1482 16.875C12.1482 16.5514 11.8859 16.2891 11.5623 16.2891Z"
          fill={c}
        />
      </g>
      <defs>
        <clipPath id="clip0_6001_16063">
          <rect width="20" height="20" fill={c} />
        </clipPath>
      </defs>
    </SvgIcon>
  );
};

export default PrinterIcon;
